<!-- 支付订单流水 -->
<template>
  <div style="padding: 20px">
    <!-- 查询搜索表单 -->
    <el-form :inline="true" :model="queryForm" class="query-form-inline">
      <el-form-item item label="开发者名称">
        <el-input
          v-model="queryForm.developer_name"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item item label="APPID">
        <el-input v-model="queryForm.appid" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item item label="应用名称">
        <el-input v-model="queryForm.app_name" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item item label="付款用户ID">
        <el-input v-model="queryForm.payer_id" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item item label="TXID">
        <el-input v-model="queryForm.txid" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item item label="订单编号">
        <el-input v-model="queryForm.order_id" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="支付日期（UTC）">
        <el-date-picker
          v-model="queryForm.date_range"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="timestamp"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onQuery">查询</el-button>
        <el-button @click="onClear">清空</el-button>
      </el-form-item>
    </el-form>
    <div style="margin-bottom: 20px;">
      <el-button
        :loading="exportLoading"
        type="primary"
        size="default"
        @click="handleExportExcel"
      >
        导出Excel
      </el-button>
    </div>
    <!-- 表格 -->
    <el-table :data="records" border stripe row-key="no">
      <el-table-column prop="no" label="序号"> </el-table-column>
      <el-table-column prop="developer_name" label="开发者名称">
      </el-table-column>
      <el-table-column prop="appid" label="APPID"></el-table-column>
      <el-table-column prop="app_name" label="应用名称"></el-table-column>
      <el-table-column prop="payer_name" label="付款方名称"></el-table-column>
      <el-table-column prop="payer_id" label="付款用户ID"> </el-table-column>
      <el-table-column prop="payment_type" label="款项类型"></el-table-column>
      <el-table-column prop="txid" label="TXID"></el-table-column>
      <el-table-column prop="order_id" label="订单编号"></el-table-column>
      <el-table-column prop="product_name" label="商品名称"></el-table-column>
      <el-table-column prop="order_amount" label="订单金额"></el-table-column>
      <el-table-column
        prop="order_amount_unit"
        label="订单金额单位"
      ></el-table-column>

      <el-table-column
        prop="payment_amount_without_fee"
        label="支付金额(不含矿工费)"
      ></el-table-column>
      <el-table-column
        prop="payment_amount_with_fee"
        label="支付金额(含矿工费)"
      ></el-table-column>
      <el-table-column
        prop="payment_amount_unit"
        label="支付金额单位"
      ></el-table-column>

      <el-table-column
        prop="payment_time"
        label="支付时间（UTC）"
      ></el-table-column>
      <el-table-column prop="payee_name" label="收款方名称"></el-table-column>
      <el-table-column prop="payee_id" label="收款用户ID"></el-table-column>
    </el-table>
    <div style="margin-top: 20px">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { getOrderPaymentRecords } from "@/api/developer.js";
import { export_json_to_excel } from "@/utils/export2excel";
const EXPORT_PAGE_SIZE = 100;
const hour2Second = (hour) => hour * 60 * 60;

export default {
  data() {
    return {
      queryForm: {
        developer_name: "",
        appid: "",
        app_name: "",
        payer_id: "",
        txid: "",
        order_id: "",
        date_range: "",
      },
      page: 1,
      pageSize: 20,
      total: 0,
      records: [],
      exportLoading: false,
    };
  },
  mounted() {
    this.fetchList();
  },
  methods: {
    async fetchList() {
      try {
        const params = this.generateQueryParams();
        const { data } = await getOrderPaymentRecords(params);
        this.records = data.data.list || [];
        this.total = data.data.total || 0;
      } catch (error) {
        this.records = [];
        this.total = 0;
      }
    },
    onQuery() {
      this.page = 1;
      this.pageSize = 20;
      this.fetchList();
    },
    onClear() {
      this.queryForm = {
        developer_name: "",
        appid: "",
        app_name: "",
        payer_id: "",
        txid: "",
        order_id: "",
        date_range: "",
      };
      this.page = 1;
      this.pageSize = 20;
    },
    handleCurrentChange(page) {
      this.page = page;
      this.fetchList();
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.fetchList();
    },
    handleStatusChange() {
      this.page = 1;
      this.pageSize = 20;
      this.fetchList();
    },
    // 生成查询参数
    generateQueryParams() {
      const { date_range, ..._params } = this.queryForm;
      const params = {
        ..._params,
        page: this.page,
        page_size: this.pageSize,
      };

      // 开始时间和结束时间
      if (Array.isArray(date_range)) {
        const start_at = Math.floor(date_range[0] / 1000);
        let end_at = Math.floor(date_range[1] / 1000);

        // 结束时间默认加 60 * 60 * 24 秒;
        end_at += hour2Second(24);

        params.start_at = start_at + hour2Second(8);
        params.end_at = end_at + hour2Second(8);
      }
      return params;
    },
    async fetchExportData() {
      let exportData = [];
      try {
        const params = this.generateQueryParams();
        const { data } = await getOrderPaymentRecords({
          ...params,
          page: 1,
          page_size: EXPORT_PAGE_SIZE,
        });
        exportData = data.data.list || [];
        const total = data.data.total || 0;
        // 不需要请求多个接口返回所有数据
        if (total <= EXPORT_PAGE_SIZE) {
          return exportData;
        } else {
          // 请求多个接口查询所有数据
          const totalPage = Math.ceil(total / EXPORT_PAGE_SIZE);

          const fetchPromiseList = [];
          for (let i = 2; i <= totalPage; i++) {
            fetchPromiseList.push(
              getOrderPaymentRecords({
                ...params,
                page: i,
                page_size: EXPORT_PAGE_SIZE,
              })
            );
          }

          const responseList = await Promise.all(fetchPromiseList);
          responseList.forEach((response) => {
            const list =
              (response &&
                response.data &&
                response.data.data &&
                response.data.data.list) ||
              [];
            exportData = [...exportData, ...list];
          });
          return exportData;
        }
      } catch (error) {
        return [];
      }
    },
    async handleExportExcel() {
      if (this.exportLoading) {
        return;
      }
      this.exportLoading = true;
      const exportData = await this.fetchExportData();
      const data = exportData.map((item) => {
        return [
          item.no,
          item.developer_name,
          item.appid,
          item.app_name,
          item.payer_name,
          item.payer_id,
          item.payment_type,
          item.txid,
          item.order_id,
          item.product_name,
          item.order_amount,
          item.order_amount_unit,
          item.payment_amount_without_fee,
          item.payment_amount_with_fee,
          item.payment_amount_unit,
          item.payment_time,
          item.payee_name,
          item.payee_id,
        ];
      });
      export_json_to_excel({
        header: [
          "序号",
          "开发者名称",
          "APPID",
          "应用名称",
          "付款方名称",
          "付款用户ID",
          "款项类型",
          "TXID",
          "订单编号",
          "商品名称",
          "订单金额",
          "订单金额单位",
          "支付金额(不含矿工费)",
          "支付金额(含矿工费)",
          "支付金额单位",
          "支付时间（UTC）",
          "收款方名称",
          "收款用户ID",
        ],
        data: data, //具体数据 必填
        filename: "应用支付流水",
        autoWidth: true, //非必填
        bookType: "xlsx", //非必填
      });
      this.exportLoading = false;
    },
  },
};
</script>

<style lang="less" scoped></style>
